module.exports = __webpack_public_path__ + "img/2_001.e07465c2.webp";